/// REDUX ///
import { Dispatch } from "redux";
/// TYPES ///
import { Label } from "api/types/sketch";
/// ACTIONS ///
import { Action } from "api/action_types/sketch";
/// ACTION TYPES ///
import { ActionType } from "api/action_types/sketch";

export const updateLocalLabel = (label: Label) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.UPDATE_LOCAL_LABEL,
            label
        });
    }
}